import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 2.81217C15.5 3.14447 15.2281 3.41634 14.8958 3.41634H1.60417C1.27187 3.41634 1 3.14447 1 2.81217C1 2.47988 1.27187 2.20801 1.60417 2.20801H14.8958C15.2281 2.20801 15.5 2.47988 15.5 2.81217ZM10.0625 13.083H6.4375C6.10521 13.083 5.83333 13.3549 5.83333 13.6872C5.83333 14.0195 6.10521 14.2913 6.4375 14.2913H10.0625C10.3948 14.2913 10.6667 14.0195 10.6667 13.6872C10.6667 13.3549 10.3948 13.083 10.0625 13.083ZM12.4792 7.64551H4.02083C3.68854 7.64551 3.41667 7.91738 3.41667 8.24967C3.41667 8.58197 3.68854 8.85384 4.02083 8.85384H12.4792C12.8115 8.85384 13.0833 8.58197 13.0833 8.24967C13.0833 7.91738 12.8115 7.64551 12.4792 7.64551Z"
      fill="#151718"
    />
  </svg>
);

const FilterIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default FilterIcon;
